import { Switch } from "@/shared/ui/switch";
import { Label } from "@/shared/ui/label";
import { DatePickerField } from "./DatePickerField";

interface SubscriptionFieldProps {
  subscribed: boolean;
  onSubscribedChange: (checked: boolean) => void;
  expiresAt: Date | null;
  onExpiresAtChange: (date: Date | null) => void;
  formErrors: { [key: string]: string };
}

export function SubscriptionField({
  subscribed,
  onSubscribedChange,
  expiresAt,
  onExpiresAtChange,
  formErrors,
}: SubscriptionFieldProps) {
  return (
    <div className="flex items-start gap-8">
      <div className="w-[320px]">
        <div className="flex items-center justify-between mb-2">
          <Label htmlFor="subscribed" className="text-white text-base">
            Assinatura
          </Label>
          <div className="pointer-events-none opacity-50">

            <Switch
              id="subscribed"
              checked={subscribed}
              onCheckedChange={onSubscribedChange}
              className="data-[state=checked]:bg-[#1677FF]"

            />
          </div>
        </div>
        <div className="pointer-events-none opacity-50">

          <DatePickerField
            label="Assinatura"
            sublabel="Assinatura até o dia"
            date={expiresAt}
            onDateChange={onExpiresAtChange}
          />
        </div>
        {formErrors.subscription && (
          <p className="text-sm text-red-500">{formErrors.subscription}</p>
        )}
      </div>
    </div>
  );
}
